<template>
  <div id="base-index-template">
    <div v-if="$slots['sub-nav']" :class="{offset: $route.path.includes('discover')}" class="mr-subheader">
      <div class="mr-subheader__inner">
        <slot name="sub-nav" />
      </div>
    </div>
    <section v-if="$slots['grid']" :class="{offset: $route.path.includes('discover')}" class="mr-index">
      <div  class="mr-index__inner">
        <slot name="grid" />
      </div>
      <div v-if="$slots['loader']" class="mr-index__loader">
        <slot name="loader" />
      </div>
    </section>
    <section v-if="$slots['not-found']" class="not-found">
      <slot name="not-found" />
    </section>
  </div>
</template>
<script>
export default {
  name: 'BaseIndexTemplate'
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/templates/_base-archive.scss';
</style>
